<template>
	<Container>
		<Title>
			{{ $t('offices') }}
		</Title>
		<div>
			<div class="flex w-full flex justify-end">
				<div class="lg:w-1/3 flex lg:mr-3 mb-4">
					<img src="@/assets/img/buscar.svg" class="p-2" />
					<input
						v-model="search"
						@keyup="loadData"
						class="
							w-24R
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
						v-bind:placeholder="$t('search')"
					/>
				</div>
				<ButtonBlack>
					<router-link :to="'/' + section" class="text-white no-underline">
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
			<ListTable
				:itemsTitles="itemsTitles"
				:items="organizations_offices"
				:section="section"
				:itemsTable="itemsTable"
			/>
		</div>
	</Container>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		organizations_offices: {
			query: gql`
				query ($delegation_id: bigint!) {
					organizations_offices(
						order_by: { office_name: asc }
						where: { delegation_id: { _eq: $delegation_id } }
					) {
						id
						office_name
						city
						state {
							name
						}
						phone
						email
						active
					}
				}
			`,
			variables() {
				return {
					delegation_id: this.id
				}
			},
			update(data) {
				return data.organizations_offices.map(item => ({
					id: item.id,
					name: item.office_name,
					city: item.city,
					state: item.state.name,
					phone: item.phone,
					email: item.email,
					edit: true,
					active: item.active
				}))
			}
		}
	},
	data() {
		return {
			section: `admin/oficina/${this.id}`,
			itemsTable: 'organizations_offices',
			itemsTitles: ['Id', 'Nombre', 'city', 'state', 'Telefono', 'email']
		}
	},
	components: { ListTable },
	props: {
		id: String
	}
}
</script>
